/* eslint-disable @typescript-eslint/no-explicit-any */
import ShowAddressLabel from '../../utils/showAddressLabel'

const getDeliveryText = ({
  copies,
  enabledOpModelSuffix,
  address,
  showAddressLabel,
}: {
  copies: any
  enabledOpModelSuffix: boolean
  address: any
  showAddressLabel: boolean
}) => {
  const addressLabel = ShowAddressLabel({ address, showAddressLabel }) || ''

  if (enabledOpModelSuffix) {
    const { opModel } = copies.header?.subheader || {}
    return `${addressLabel} ${opModel?.suffixDelivery || ''}`
  }

  return addressLabel || ''
}

export default getDeliveryText
